export var actions;
(function (actions) {
    actions["init"] = "init";
    actions["mergeFilters"] = "mergeFilters";
    actions["replaceFilters"] = "replaceFilters";
    actions["replaceDisplayedFilters"] = "replaceDisplayedFilters";
    actions["displayFilter"] = "displayFilter";
    actions["removeFilter"] = "removeFilter";
    actions["remove"] = "remove";
    actions["resetFilters"] = "resetFilters";
    actions["displayAllFilters"] = "displayAllFilters";
    actions["removeAllFilters"] = "removeAllFilters";
    actions["setCache"] = "setCache";
})(actions || (actions = {}));
//# sourceMappingURL=actions.js.map